import React from 'react';
const TABLEAU_API_URL = 'https://tableau.tapila.cloud';

const Tableau = ({ src, token }: { src: string, token: string }) => {

  const customHtml = `<tableau-viz id="tableauViz" 
    src="${TABLEAU_API_URL}/#/views/TapiBillPayments/${src}?:iid=1" 
    token=${token}  
    device="default" 
    toolbar="hidden" 
    hide-tabs 
    suppressDefaultEditBehavior=1 > 
  </tableau-viz>`
  return (
    <div dangerouslySetInnerHTML={{ __html: customHtml }} />
  )
};

export default Tableau;
